






import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Gallery from "@/components/Gallery.vue";

@Component({
  name: "Ireland",
  components: {
    Gallery
  }
})
export default class Ireland extends Vue {
  // eslint-disable-next-line
  @Prop() private assets!: any;
}
